<div class="strength" role="status" [attr.aria-label]="'account.passwordStrength.' + level() | transloco">
  <div class="strength__bars">
    @for (filled of segments(); track $index) {
      <span
        class="strength__bar"
        [class.strength__bar--filled]="filled"
        [class.strength__bar--weak]="filled && level() === 'weak'"
        [class.strength__bar--acceptable]="filled && level() === 'acceptable'"
        [class.strength__bar--good]="filled && level() === 'good'"
        [class.strength__bar--strong]="filled && level() === 'strong'"
      ></span>
    }
  </div>
  @if (password()) {
    <span
      class="strength__label"
      [class.strength__label--acceptable]="level() === 'acceptable'"
      [class.strength__label--good]="level() === 'good'"
      [class.strength__label--strong]="level() === 'strong'"
    >
      {{ 'account.passwordStrength.' + level() | transloco }}
    </span>
  }
</div>
